import axios from "axios";

import Config from "./Config";
import APIHelper from "./APIHelper";

const BASE = `${Config.API_URL}product-attributes-dictionary`;

const crud = (base) => ({
    all() {
        return axios
            .get(base)
            .then(APIHelper.returnRows)
            .catch(APIHelper.returnFalse);
    },
    create(payload) {
        return axios
            .post(base, payload)
            .then((response) => APIHelper.returnAttribute(response, "row"))
            .catch((error) => {
                const message = error.response?.data?.message;
                return message ? { message } : false;
            });
    },
    save(id, payload) {
        return axios
            .put(`${base}/${encodeURIComponent(id)}`, payload)
            .then(APIHelper.checkStatus)
            .catch(APIHelper.returnFalse);
    },
    delete(id) {
        return axios
            .delete(`${base}/${encodeURIComponent(id)}`)
            .then(APIHelper.checkStatus)
            .catch((error) => {
                const message = error.response?.data?.message;
                return message ? { message } : false;
            });
    },
});

const ProductAttributeDictionaryService = {
    units: crud(BASE),
    composites: crud(`${BASE}/composite`),
};

export default ProductAttributeDictionaryService;
